<template>
    <tr v-show="!item.is_edit" @click="openEditLine(index)">
        
        <td class="pl-10">
            <div class="col">
                <strong>
                  {{ item.name }}
                </strong>
                {{ item.description }}
              <button class="btn btn-sm p-0" @click.stop="onOpenDentitionModal">
                <i class="fas fa-teeth"></i>
              </button>
            </div>
        </td>
        <td class="text-center">{{ item.service_resource ? item.service_resource.name : '' }}</td>
        <td class="text-center">{{ item.schedule_date ? formatDate(new Date(item.schedule_date)) : '' }}</td>
        <td class="text-center">{{ item.quantity }}</td>
        <td class="text-center">{{ item.rate }}</td>
        <td class="text-center">{{ item.amount }}</td>
        <td class="text-center">{{ item.discount_percent }}%</td>
        <td class="text-center">{{ item.discount_amount }}</td>
        <td class="text-center">{{ amountAfterDiscount }}</td>
        <td class="text-center">{{ totalAmount }}</td>
        <td class="action-td">
            <div class="d-flex align-items-center justify-content-center">
                <div class="dropdown" v-if="!item.invoice_qty && index > 0">
                    <button class="btn btn-sm dropdown-toggle hide-arrow p-0 ms-1" type="button" data-bs-toggle="dropdown" aria-expanded="false" @click.stop>
                        <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                        <li>
                            <a class="dropdown-item text-danger" href="javascript:void(0)" @click.stop="deleteItem(index)">
                                <i class="fas fa-trash me-2"></i>
                                <span>Delete</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </td>
    </tr>
    
    <tr v-show="item.is_edit" :class="item.is_edit && 'tr-box-shadow tr-edit'">
        <td class="td-min-150">
            <div class="col">
                <strong>
                    {{ item.name }}
                </strong>
                {{ item.description }}
              <button class="btn btn-sm p-0" @click.stop="onOpenDentitionModal">
                <i class="fas fa-teeth"></i>
              </button>
            </div>
        </td>
        <td class="td-min-150">
          <AsyncSelect
            placeholder="Select service resource"
            v-model="item.service_resource"
            :autoSelectFirst="true"
            :api-service="fetchContactProfiles"
            :additional-query="additionalQuery"
          />
        </td>
        <td class="td-min-150">
            <div class="input-group input-group-merge w-100">
                <input
                    name="datetime"
                    type="datetime-local"
                    class="form-control"
                    v-model="item.schedule_date"
                />
            </div>
        </td>
        <td>
            <div class="td-inline">
                <input
                    v-model.trim="item.quantity"
                    type="number" class="form-control"
                    placeholder="Qty" :min="0"
                >
            </div>
        </td>
        <td>
            <div class="td-inline">
                <input
                    v-model.trim="item.rate"
                    type="number" class="form-control"
                    placeholder="Rate" :min="0"
                >
            </div>
        </td>
        <td>
            <div class="td-inline">
                <vField
                    readonly
                    v-model="amount"
                    name="amount text-right"
                    type="number"
                    class="form-control text-right"
                />
            </div>
        </td>
        <td>
            <div class="td-inline">
                <input
                    v-model.trim="item.discount_percent"
                    type="number" class="form-control"
                    placeholder="Discount(%)" :min="0"
                >
            </div>
        </td>
        <td>
            <div class="td-inline">
                <vField
                    v-model="item.discount_amount"
                    name="discount-amount"
                    type="number"
                    class="form-control text-right"
                    min="0"
                />
            </div>
        </td>
        <td>
            <div class="td-inline">
                <vField
                    v-model="amountAfterDiscount"
                    name="amount"
                    type="number"
                    class="form-control text-right"
                />
            </div>
        </td>
        <td>
            <div class="td-inline">
                <vField
                    v-model="totalAmount"
                    readonly
                    name="total_amount"
                    type="number"
                    class="form-control text-right"
                />
            </div>
        </td>
        <td class="action-td">
            <div class="d-flex align-items-center justify-content-center">
                <div class="dropdown" v-if="!item.invoice_qty && index > 0">
                    <button class="btn btn-sm dropdown-toggle hide-arrow p-0 ms-1" type="button" data-bs-toggle="dropdown" aria-expanded="false" @click.stop>
                        <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                        <li>
                            <a class="dropdown-item text-danger" href="javascript:void(0)" @click.stop="deleteItem(index)">
                                <i class="fas fa-trash me-2"></i>
                                <span>Delete</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </td>
    </tr>

</template>
<script setup>
import {computed, inject, onMounted, ref, watch} from "vue";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import {useRoute} from "vue-router";
import handleContact from "@/services/modules/contact";
import handleHospital from "@/services/modules/hospital";
import { formatDate } from '@/services/utils/global.js';

const props = defineProps(['item', 'index', 'onOpenEditItem', 'onDeleteItem', 'vatRate'])
const emit = defineEmits(['onOpenEditItem', 'onDeleteItem', 'onOpenDentitionModal']);
const {fetchContactProfiles} = handleContact()
const {fetchServiceResource} = handleHospital();
const $route = useRoute();
const showError = inject('showError')
const companyId = $route.params.companyId
const additionalQuery = {
  roles: "doctor,medical_officer",
}
const additionalProductQuery = {
    product_type: "services"
}
const serviceResourceDescriptions = ref([]);

const openEditLine = (i) => {
    emit('onOpenEditItem', i)
}
const deleteItem = (i) => {
    emit('onDeleteItem', i)
}

const amount = computed(() => props.item.amount = props.item.rate * props.item.quantity)
const discountPercent = computed(() => props.item.discount_percent);
const amountAfterDiscount = computed(() => {
    return amount.value - (parseFloat(props.item.discount_amount) || 0);
})

const serviceResourceId = computed(() => props.item.service_resource)
const serviceResourceDescId = computed(() => props.item.resource_description_id)
const totalAmount = computed(() => {
    if(props.item.vat == 0) {
        return props.item.total_amount = amountAfterDiscount.value
    }
    return props.item.total_amount = parseInt(amountAfterDiscount.value) + parseInt(props.item.vat_amount)
})

const onOpenDentitionModal = () => {
  emit('onOpenDentitionModal', props.item, props.index)
}

watch(() => props.item.dentition, () => {
  if (!props.item.dentition || !props.item.dentition.length || props.item.id) return;
  
  props.item.quantity = props.item.dentition.length || 1;
}, {deep: true})

watch(serviceResourceId, () => {
  serviceResourceDescriptions.value = [];
  if (serviceResourceId.value) {
    const companyQuery = `?company_id=${companyId}`;
    const previousDescriptionId = props.item.resource_description_id;
    const previousServiceResourcePrice = props.item.service_resource_price;

    props.item.service_resource_id = serviceResourceId.value.id
    props.item.service_resource_name = serviceResourceId.value.name
    props.item.resource_description_id = null;
    props.item.service_resource_desc_name = null;
    props.item.service_resource_price = null;
    props.item.cost_of_sales_account_head_id = null;
    fetchServiceResource(serviceResourceId.value.id, companyQuery).then(res => {
      if (res.data) {
        serviceResourceDescriptions.value = res.data.resource_descriptions.map(rd => {
            return {
              ...rd,
              name: rd.service_name + (rd.service_specification ? ` (${rd.service_specification})` : "")
            }
        })
      }
      const exists = serviceResourceDescriptions.value.find(desc => desc.id === previousDescriptionId);
      if (exists && res.data) {
        props.item.resource_description_id = previousDescriptionId;
        props.item.service_resource_price = previousServiceResourcePrice;
      }
    })
  }
}, {
  deep:true
})

watch(serviceResourceDescId, (newValue) => {
  if (newValue) {
    const description = serviceResourceDescriptions.value.find(srd => srd.id === newValue);
    props.item.service_resource_desc_name = description.name;
    props.item.service_resource_price = (props.item.resource_description_id === props.item.service_resource_description_id && props.item.service_resource_price) ?
        props.item.service_resource_price : description.cost_of_sales_price;
    props.item.cost_of_sales_account_head_id = description.cost_of_sales_account_head_id;
  }
})

watch(discountPercent, (value) => {
    let discount = 0;
    value = parseFloat(value);
    if(value && value > 0 && amount.value > 0) {
      discount = amount.value * (value/100);
    }
    props.item.discount_percent = value;
    props.item.discount_amount = discount.toFixed(2);
})

onMounted(() => {

    if(props.item.service_resource_description_id) {

        props.item.resource_description_id = props.item.service_resource_description_id;
        props.item.service_resource_price = props.item.service_resource_price ? props.item.service_resource_price : props.item.cost_of_sales_price;
        props.item.cost_of_sales_account_head_id = props.item.cost_of_sales_account_head_id;

        serviceResourceDescriptions.value.push({
            id: props.item.service_resource_description_id,
            name: props.item.service_resource_desc_name,
            cost_of_sales_price: props.item.cost_of_sales_price,
            cost_of_sales_account_head_id: props.item.cost_of_sales_account_head_id
        })
    }
});

</script>
<style scoped>
.tr-edit td{
  min-width: 80px;
}
.td-min-150 {
    min-width: 150px;
}
.action-td {
    width: 1%;
    white-space: nowrap;
}
</style>